import AdminAuth from "@/views/Admin/Others/AdminAuth";
import AdminMain from "@/views/Admin/Main";
import AdminMethodsList from "@/views/Admin/Methods/MethodsList";
import MethodAdd from "@/views/Admin/Methods/MethodAdd";
import MethodEdit from "@/views/Admin/Methods/MethodEdit";
import ThemeList from "@/views/Admin/Themes/ThemeList";
import ThemeAdd from "@/views/Admin/Themes/ThemeAdd";
import ThemeEdit from "@/views/Admin/Themes/ThemeEdit";
import PreviewList from "@/views/Admin/Previews/PreviewList";
import PreviewAdd from "@/views/Admin/Previews/PreviewAdd";
import PreviewEdit from "@/views/Admin/Previews/PreviewEdit";

export default [
  {
    path: '/admin',
    name: 'Admin',
    component: AdminMain,
    meta: {layout: 'Admin'},
  },

  {
    path: '/admin/admin_auth',
    name: 'AdminAuth',
    meta: {layout: 'Empty'},
    component: AdminAuth,
  },
  {
    path: '/admin/methods',
    name: 'AdminMethods',
    meta: {layout: 'Admin'},
    component: AdminMethodsList,
  },
  {
    path: '/admin/methods/add',
    name: 'MethodAdd',
    meta: {layout: 'Admin'},
    component: MethodAdd,
  },
  {
    path: '/admin/methods/edit/:method_id_q',
    props: true,
    name: 'MethodEdit',
    meta: {layout: 'Admin'},
    component: MethodEdit,
  },

  {
    path: '/admin/themes',
    name: 'Themes',
    meta: {layout: 'Admin'},
    component: ThemeList,
  },
  {
    path: '/admin/themes/add',
    name: 'ThemeAdd',
    meta: {layout: 'Admin'},
    component: ThemeAdd,
  },
  {
    path: '/admin/themes/edit/:theme_id_q',
    props: true,
    name: 'ThemeEdit',
    meta: {layout: 'Admin'},
    component: ThemeEdit,
  },

  {
    path: '/admin/previews',
    name: 'Previews',
    meta: {layout: 'Admin'},
    component: PreviewList,
  },
  {
    path: '/admin/previews/add',
    name: 'PreviewAdd',
    meta: {layout: 'Admin'},
    component: PreviewAdd,
  },
  {
    path: '/admin/previews/edit/:id',
    props: true,
    name: 'PreviewEdit',
    meta: {layout: 'Admin'},
    component: PreviewEdit,
  },

  {
    path: '/admin_auth',
    name: 'AdminAuth',
    meta: {layout: 'Empty'},
    component: AdminAuth,
  },
]
